// set asset_host for webpack dynamic imports
/* eslint-disable camelcase, no-unused-vars, no-global-assign */
/* global __webpack_public_path__ */
if (window.gon?.assetHost) {
  __webpack_public_path__ = `${window.gon.assetHost}/assets/`
}
/* eslint-enable camelcase, no-unused-vars, no-global-assign */

// for GI and testing in the browser console
import "../error_reporter_boot"
import "../experiments/init"
import questionBannerForVisitorsOnArticles
  from "../experiments/question_banner_for_visitors_on_articles"
import pageLoad from "../page_load"
import loadMedia from "../load_media"

import "stylesheets/site/essential.scss"
import keysToCamel from "../keys_to_camel"

async function loadInit() {
  await loadApplicationCss()
  await loadFonts()
  setCssVariables()
  pageLoad.onReady(loadApplicationCss)
  // Direct trigger for question banner, bypassing GrowthBook
  pageLoad.onReady(() => {
    questionBannerForVisitorsOnArticles()
  })
  return import(/* webpackChunkName: "init" */ "init").catch(e => {
    const noticeElement = document.querySelector("#offline_messages .notice")
    if (noticeElement) noticeElement.style.display = "block"
    // eslint-disable-next-line no-console
    console.error(e)
  })
}

function loadApplicationCss() {
  return loadMedia(document.getElementById("deferred_styles"))
}

function loadFonts() {
  if (!("fonts" in document)) return Promise.resolve()

  return Promise.all([
    document.fonts.load("12px 'PlutoSansLight'"),
    document.fonts.load("12px 'PlutoSansMedium'"),
    document.fonts.load("12px 'PlutoSansRegular'"),
    document.fonts.load("12px 'PlutoLightItalic'")
  ])
}

function setCssVariables() {
  document.documentElement.style
    .setProperty(
      "--light",
      "PlutoSansLight, PlutoSansLightFull, Helvetica, Arial, sans-serif"
    )
  document.documentElement.style
    .setProperty(
      "--medium",
      "PlutoSansMedium, PlutoSansMediumFull, Helvetica, Arial, sans-serif"
    )
  document.documentElement.style
    .setProperty(
      "--regular",
      "PlutoSansRegular, PlutoSansRegularFull, Helvetica, Arial, sans-serif"
    )
  document.documentElement.style.setProperty(
    "--light-italic",
    "PlutoLightItalic, PlutoLightItalicFull, Helvetica, Arial, sans-serif"
  )
}

window.addEventListener("load", loadInit)

// prevent the pwa install prompt for visitors
// https://web.dev/customize-install/
if (!window.gon.currentUser) {
  window.addEventListener("beforeinstallprompt", (e) => e.preventDefault())
}

// displays the page after the experiment code was executed
// has to be executed one execution cycle later because otherwise the
// experiments would still flicker
pageLoad.onReady(() => {
  document.documentElement.classList.remove("async-hide")

  // temporary fix for cached gon data
  window.gon = keysToCamel(window.gon)
  window.gon.searchAPIImagesPath = window.gon.searchApiImagesPath
  window.gon.galleryAPIImagesPath = window.gon.galleryApiImagesPath
  window.gon.reviewQuizAPIUserPath = window.gon.reviewQuizApiUserPath
})

// makes them accessible from the outside
export {default as storage} from "storage"
